module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "viewWrapper",
    staticClass: "view clearfix"
  }, [_c('topBanner'), _vm._v(" "), _c('navigation'), _vm._v(" "), _c('div', {
    class: {
      w1080: _vm.rwidth, w100: _vm.Lwidth
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d34fba8a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/page/web.vue
// module id = 1244
// module chunks = 1